import "../styles/TipoA.css";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
  FaArrowLeft,
  FaArrowRight,
  FaBed,
  FaCalendarDays,
  FaCar,
  FaCheck,
  FaCouch,
  FaDoorOpen,
  FaKitchenSet,
  FaRulerCombined,
  FaShirt,
  FaSun,
} from "react-icons/fa6";

import imagenTipoA from "../assets/proyecto7.jpg";

const whatsappLink =
  "https://wa.me/18299623399?text=Hola%2C%20me%20interesa%20recibir%20más%20información%20sobre%20el%20Apartamento%20Tipo%20A%20de%20Residencial%20YANNA%20I.";

const estadisticas = [
  {
    icono: <FaRulerCombined />,
    numero: "144.79",
    unidad: "m²",
    texto: "Área total",
  },
  {
    icono: <FaBed />,
    numero: "3",
    unidad: "",
    texto: "Habitaciones",
  },
  {
    icono: <FaCar />,
    numero: "25",
    unidad: "m²",
    texto: "Área de parqueo",
  },
  {
    icono: <FaSun />,
    numero: "1",
    unidad: "",
    texto: "Terraza privada",
  },
];

const especificaciones = [
  {
    numero: "01",
    icono: <FaBed />,
    titulo: "Tres habitaciones",
    descripcion:
      "Espacios privados y amplios, pensados para brindar descanso, comodidad y privacidad.",
  },
  {
    numero: "02",
    icono: <FaDoorOpen />,
    titulo: "Walk-in closets",
    descripcion:
      "Áreas de almacenamiento amplias que aportan organización y funcionalidad.",
  },
  {
    numero: "03",
    icono: <FaCouch />,
    titulo: "Sala y comedor",
    descripcion:
      "Una zona social abierta y elegante, diseñada para compartir momentos especiales.",
  },
  {
    numero: "04",
    icono: <FaKitchenSet />,
    titulo: "Cocina contemporánea",
    descripcion:
      "Una cocina moderna con una distribución práctica y excelente aprovechamiento.",
  },
  {
    numero: "05",
    icono: <FaSun />,
    titulo: "Terraza privada",
    descripcion:
      "Un espacio exclusivo que aporta iluminación, ventilación y conexión con el exterior.",
  },
  {
    numero: "06",
    icono: <FaShirt />,
    titulo: "Área de lavado",
    descripcion:
      "Zona independiente para realizar las tareas del hogar con mayor comodidad.",
  },
  {
    numero: "07",
    icono: <FaDoorOpen />,
    titulo: "Cuarto de servicio",
    descripcion:
      "Un espacio adicional que complementa la funcionalidad de esta residencia.",
  },
  {
    numero: "08",
    icono: <FaCar />,
    titulo: "Parqueo de 25 m²",
    descripcion:
      "Amplia área de estacionamiento destinada a ofrecer comodidad y seguridad.",
  },
];

const revelar = {
  oculto: {
    opacity: 0,
    y: 50,
  },

  visible: {
    opacity: 1,
    y: 0,

    transition: {
      duration: 0.85,
      ease: "easeOut",
    },
  },
};

function TipoA() {
  return (
    <main className="tipoAVip">
      {/* HERO SIN IMAGEN */}

      <section className="tipoAVipHero">
        <div className="tipoAVipHeroGlow tipoAVipHeroGlowOne"></div>
        <div className="tipoAVipHeroGlow tipoAVipHeroGlowTwo"></div>

        <motion.div
          className="tipoAVipHeroContainer"
          initial={{ opacity: 0, y: 45 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.95,
            ease: "easeOut",
          }}
        >
          <Link to="/" className="tipoAVipBack">
            <FaArrowLeft />
            Volver
          </Link>

          <div className="tipoAVipEyebrow">
            <span></span>
            COLECCIÓN PREMIUM
            <span></span>
          </div>

          <h1>
            Apartamento
            <strong>Tipo A</strong>
          </h1>

          <p className="tipoAVipHeroDescription">
            La propuesta residencial más exclusiva de YANNA I. Una
            vivienda de gran amplitud, diseñada para quienes valoran
            la privacidad, el confort y una arquitectura
            contemporánea.
          </p>

          <p className="tipoAVipHeroDescriptionSecondary">
            Sus 144.79 m² integran espacios sociales elegantes, tres
            habitaciones, terraza privada y áreas de servicio
            cuidadosamente distribuidas.
          </p>

          <div className="tipoAVipPricePanel">
            <div className="tipoAVipPriceItem">
              <span>PRECIO DE VENTA</span>
              <strong>US$194,308.18</strong>
            </div>

            <div className="tipoAVipPriceDivider"></div>

            <div className="tipoAVipPriceItem">
              <span>MONTO DE RESERVA</span>
              <strong>US$5,000</strong>
            </div>
          </div>

          <div className="tipoAVipHeroButtons">
            <Link
              to="/reserva"
              className="tipoAVipButton tipoAVipButtonPrimary"
            >
              Reservar apartamento
              <FaArrowRight />
            </Link>

            <Link
              to="/reserva"
              className="tipoAVipButton tipoAVipButtonSecondary"
            >
              <FaCalendarDays />
              Agendar una visita
            </Link>
          </div>

          <p className="tipoAVipReservationNote">
            Unidad premium disponible con una reserva inicial de
            <strong> US$5,000.</strong>
          </p>
        </motion.div>
      </section>

      {/* DATOS PRINCIPALES */}

      <section className="tipoAVipStats">
        <div className="tipoAVipStatsContainer">
          {estadisticas.map((item, index) => (
            <motion.article
              key={item.texto}
              className="tipoAVipStatCard"
              initial={{
                opacity: 0,
                y: 35,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
                amount: 0.2,
              }}
              transition={{
                duration: 0.55,
                delay: index * 0.1,
              }}
              whileHover={{
                y: -9,
              }}
            >
              <div className="tipoAVipStatIcon">
                {item.icono}
              </div>

              <div className="tipoAVipStatValue">
                <strong>{item.numero}</strong>

                {item.unidad && (
                  <span>{item.unidad}</span>
                )}
              </div>

              <p>{item.texto}</p>
            </motion.article>
          ))}
        </div>
      </section>

      {/* UNA SOLA IMAGEN CON EFECTO 3D */}

      <section className="tipoAVipShowcase">
        <motion.div
          className="tipoAVipShowcaseHeader"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >
          <span>VISTA DESTACADA</span>

          <h2>
            Una residencia que se distingue en cada detalle.
          </h2>

          <p>
            Una perspectiva completa para apreciar la amplitud, la
            distribución y el diseño exclusivo del Apartamento Tipo A.
          </p>
        </motion.div>

        <motion.div
          className="tipoAVipPhotoPerspective"
          initial={{
            opacity: 0,
            y: 60,
            scale: 0.96,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
            scale: 1,
          }}
          viewport={{
            once: true,
            amount: 0.18,
          }}
          transition={{
            duration: 1,
            ease: "easeOut",
          }}
        >
          <motion.figure
            className="tipoAVipPhotoCard"
            initial={{
              rotateY: -5,
              rotateX: 2,
            }}
            whileHover={{
              rotateY: 2,
              rotateX: 0,
              y: -12,
              scale: 1.015,
            }}
            transition={{
              duration: 0.45,
              ease: "easeOut",
            }}
          >
            <div className="tipoAVipPhotoGoldFrame"></div>

            <div className="tipoAVipPhotoCorner tipoAVipPhotoCornerTop"></div>

            <img
              src={imagenTipoA}
              alt="Vista 3D del Apartamento Tipo A"
            />

            <div className="tipoAVipPhotoGradient"></div>

            <figcaption className="tipoAVipPhotoCaption">
              <div>
                <span>RESIDENCIA PREMIUM</span>
                <strong>Apartamento Tipo A</strong>
              </div>

              <div className="tipoAVipPhotoMeta">
                <span>144.79 m²</span>

                <span className="tipoAVipAvailable">
                  <i></i>
                  Disponible
                </span>
              </div>
            </figcaption>
          </motion.figure>
        </motion.div>
      </section>

      {/* DESCRIPCIÓN SIN IMAGEN */}

      <section className="tipoAVipSignature">
        <motion.div
          className="tipoAVipSignatureContent"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >
          <span className="tipoAVipSectionLabel">
            RESIDENCIA SIGNATURE
          </span>

          <h2>
            Espacios que reflejan elegancia y distinción.
          </h2>

          <div className="tipoAVipSignatureDivider"></div>

          <p className="tipoAVipSignatureLead">
            El Apartamento Tipo A representa la propuesta más
            exclusiva de Residencial YANNA I. Su distribución combina
            amplitud, privacidad y una imagen moderna pensada para un
            estilo de vida superior.
          </p>

          <p>
            La sala, el comedor y la cocina conforman un ambiente
            abierto y sofisticado. Sus habitaciones conservan la
            privacidad necesaria, mientras que la terraza amplía la
            experiencia social y permite disfrutar de mayor
            iluminación y ventilación natural.
          </p>

          <div className="tipoAVipSignatureChecks">
            <div>
              <FaCheck />
              <span>Diseño contemporáneo</span>
            </div>

            <div>
              <FaCheck />
              <span>Distribución premium</span>
            </div>

            <div>
              <FaCheck />
              <span>Ambientes amplios</span>
            </div>

            <div>
              <FaCheck />
              <span>Terminaciones elegantes</span>
            </div>
          </div>
        </motion.div>
      </section>

      {/* CARACTERÍSTICAS */}

      <section className="tipoAVipSpecifications">
        <motion.div
          className="tipoAVipSpecificationsHeader"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >
          <span>CARACTERÍSTICAS PREMIUM</span>

          <h2>
            Una distribución completa para vivir con mayor comodidad.
          </h2>

          <p>
            Cada área fue organizada para ofrecer una experiencia
            residencial elegante, funcional y preparada para las
            necesidades de una familia moderna.
          </p>
        </motion.div>

        <div className="tipoAVipSpecificationsGrid">
          {especificaciones.map((item, index) => (
            <motion.article
              key={item.titulo}
              className="tipoAVipSpecificationCard"
              initial={{
                opacity: 0,
                y: 35,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
              }}
              transition={{
                duration: 0.55,
                delay: index * 0.06,
              }}
              whileHover={{
                y: -8,
              }}
            >
              <span className="tipoAVipSpecificationNumber">
                {item.numero}
              </span>

              <div className="tipoAVipSpecificationIcon">
                {item.icono}
              </div>

              <h3>{item.titulo}</h3>

              <p>{item.descripcion}</p>
            </motion.article>
          ))}
        </div>
      </section>

      {/* PRECIO E INVERSIÓN SIN OTRA FOTO */}

      <section className="tipoAVipInvestment">
        <div className="tipoAVipInvestmentGlow"></div>

        <motion.div
          className="tipoAVipInvestmentContent"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >
          <span>INVERSIÓN EXCLUSIVA</span>

          <h2>
            La residencia más distinguida de YANNA I.
          </h2>

          <p>
            Una propiedad de 144.79 m² creada para compradores que
            buscan amplitud, privacidad y una propuesta residencial
            con presencia.
          </p>

          <div className="tipoAVipInvestmentDetails">
            <div>
              <span>PRECIO DE VENTA</span>
              <strong>US$194,308.18</strong>
            </div>

            <div>
              <span>RESERVA INICIAL</span>
              <strong>US$5,000</strong>
            </div>
          </div>

          <div className="tipoAVipInvestmentButtons">
            <Link
              to="/reserva"
              className="tipoAVipInvestmentPrimary"
            >
              Agendar visita privada
              <FaArrowRight />
            </Link>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tipoAVipInvestmentSecondary"
            >
              Hablar con un asesor
            </a>
          </div>
        </motion.div>
      </section>

      {/* CTA FINAL SIN FOTOGRAFÍA */}

      <section className="tipoAVipFinal">
        <div className="tipoAVipFinalPattern"></div>

        <motion.div
          className="tipoAVipFinalContent"
          initial={{
            opacity: 0,
            y: 45,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
            amount: 0.25,
          }}
          transition={{
            duration: 0.9,
          }}
        >
          <span>COLECCIÓN PREMIUM YANNA I</span>

          <h2>
            Haz del Apartamento Tipo A tu próximo hogar.
          </h2>

          <p>
            Reserva con US$5,000 y permite que nuestro equipo te
            acompañe durante el proceso para conocer esta unidad
            exclusiva.
          </p>

          <div className="tipoAVipFinalButtons">
            <Link
              to="/reserva"
              className="tipoAVipFinalPrimary"
            >
              Iniciar mi reserva
              <FaArrowRight />
            </Link>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tipoAVipFinalSecondary"
            >
              Solicitar información
            </a>
          </div>
        </motion.div>
      </section>
    </main>
  );
}

export default TipoA;